import loadGoogleMapsApi from 'load-google-maps-api';
import { mapStyles } from "../utils/mapStyles";
import markerIconVoiture from "../../img/marguerite-pin-black.svg";
import markerIconUtilitaire from "../../img/marguerite-pin-white.svg";
import markerIconMixed from "../../img/marguerite-pin-orange.svg";
require("../../img/marguerite-pin-white.svg");
require("../../img/marguerite-pin-black.svg");
require("../../img/marguerite-pin-orange.svg");

export default class StationsMap extends HTMLElement {

    constructor() {
        super();

        this.markers = [];
    }

    connectedCallback() {

        this.loadMarkersDatas()
            .then((markersDatas) => {
                this.markersDatas = markersDatas;
                return this.initMap();
            })
            .catch(function (error) {
                console.error(error);
            });

    }

    // Récupère les données des marqueurs :
    // - si l'attribut data-ids (ou data-url) est présent, on va chercher le JSON côté serveur
    //   (ex. carte insérée dans un bloc de contenu générique)
    // - sinon, on lit le JSON injecté en dur dans .js-map (comportement de la page /stations)
    loadMarkersDatas() {
        const ids = this.getAttribute("data-ids");
        const customUrl = this.getAttribute("data-url");

        if (ids !== null || customUrl !== null) {
            let url = customUrl || "/Station/MapData";
            if (ids) {
                url += (url.indexOf("?") === -1 ? "?" : "&") + "ids=" + encodeURIComponent(ids);
            }
            return fetch(url, { headers: { "Accept": "application/json" } })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Erreur de chargement des stations : " + response.status);
                    }
                    return response.json();
                });
        }

        // Fallback : JSON injecté en dur dans la page
        return Promise.resolve(
            JSON.parse($('.js-map')[0].textContent.replace(",]", "]"))
        );
    }

    initMap() {

        return loadGoogleMapsApi({ key: "AIzaSyCE2SMB-JZc58WLrsajryG9A3CwaqcFpSk" }).then((googleMaps) => {

            let bounds = new googleMaps.LatLngBounds();

            let map = new googleMaps.Map(this, {
                center: { lat: 48.111778, lng: -1.680260 },
                zoom: 12,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT,
                },
                styles: mapStyles
            });

            const infowindow = new google.maps.InfoWindow({
                content: "",
            });

            for (let i in this.markersDatas) {

                let latLngById = {
                    id: this.markersDatas[i].attr,
                    lat: parseFloat(this.markersDatas[i].lat.replace(',', '.')),
                    lng: parseFloat(this.markersDatas[i].lng.replace(',', '.'))
                }

                let icon;
                
                // Sélectionner l'icône en fonction du type de véhicule
                // 0 = Voitures, 1 = Utilitaires, 2 = VoituresEtUtilitaires
                switch (this.markersDatas[i].typeVehicule) {
                    case 1: // Utilitaires
                        icon = {
                            anchor: new google.maps.Point(18, 50),
                            url: markerIconUtilitaire
                        };
                        break;
                    case 2: // VoituresEtUtilitaires
                        icon = {
                            anchor: new google.maps.Point(18, 50),
                            url: markerIconMixed
                        };
                        break;
                    case 0: // Voitures
                    default:
                        icon = {
                            anchor: new google.maps.Point(18, 50),
                            url: markerIconVoiture
                        };
                        break;
                }

                let marker = new google.maps.Marker({
                    position: latLngById,
                    title: this.markersDatas[i].name,
                    icon: icon
                });
                this.markers.push(marker);

                let contentString = `<div class="h4 mb-3">` + this.markersDatas[i].name + `</div>` + this.markersDatas[i].description + ``;

                marker.addListener('click', (e) => {
                    map.setCenter(marker.getPosition());
                    infowindow.setContent(contentString);
                    infowindow.open({
                        anchor: marker,
                        content: contentString,
                        map,
                        shouldFocus: false
                    });
                });

                bounds.extend(latLngById);
                marker.setMap(map);

            }

            map.fitBounds(bounds);

        }).catch(function (error) {
            console.error(error)
        });

    }

}

